import {shiftWorkEN} from "./time-sheet/shift-assignment/en";
import {ShiftScheduleEN} from "./time-sheet/shift-schedule/en";
import {ShiftRegistrationEN} from "./time-sheet/shift-registration/en";
import {CasualAndCompensatoryEN} from "./casual-and-compensatory/en";
import {timeSheetEN} from "./time-sheet/timesheet/en";

export const TimeKeepingEN = {
    ...shiftWorkEN,
    ...ShiftScheduleEN,
    ...ShiftRegistrationEN,
    ...CasualAndCompensatoryEN,
    ...timeSheetEN
}